export default __webpack_public_path__ + "18226f97f7aac6aca8c693e4b2e18589.jpg";